// LayoutComponent.js
import React, { useState, useEffect } from 'react';
import { Layout, Button, Space, Avatar, Dropdown, Menu } from 'antd';
import { UserOutlined, MenuOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header, Footer, Content } = Layout;

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: '#fff',
  height: 64,
  paddingInline: 24,
  backgroundColor: '#84B040',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const contentStyle = {
  textAlign: 'center',
  minHeight: 'calc(100vh - 128px)',
  padding: '24px',
  backgroundColor: '#f0f2f5',
};

const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#27292F',
};

// Define button options based on user role
const getButtonOptions = (role) => {
  if (role === 'admin') {
    return ['Products', 'Submissions', 'Users'];
  } else if (role === 'user') {
    return ['Home'];
  }
  return [];
};

// Generate menu items for the dropdown
const generateMenu = (options, handleClick) => (
  <Menu>
    {options.map((option) => (
      <Menu.Item key={option} onClick={() => handleClick(option)}>
        {option}
      </Menu.Item>
    ))}
    <Menu.Item onClick={() => handleClick('Logout')}>Logout</Menu.Item>
  </Menu>
);

const LayoutComponent = ({ children }) => {
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false);
  const [role, setRole] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Fetch role from local storage on mount
  useEffect(() => {
    const storedRole = localStorage.getItem('role');
    if (storedRole) {
      setRole(storedRole);
      setLoggedIn(true);
    }
  }, []);

  // Handle window resize to update isMobile state
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleButtonClick = (option) => {
    if (option === 'Logout') {
      setLoggedIn(false);
      setRole(null);
      localStorage.removeItem('adminToken');
      localStorage.removeItem('userToken');
      localStorage.removeItem('role'); // Clear role from local storage on logout
      navigate('/'); // Navigate to home or login page after logout
    } else if (option === 'Login') {
      navigate('/');
    }else if (option === 'Signup') {
      navigate('/signup');
    } else if (option === 'Products') {
      navigate('/admin/product'); // Navigate to admin product page
    } else if (option === 'Submissions') {
      navigate('/admin/submission'); // Navigate to admin submission page
    } else if (option === 'Users') {
      navigate('/admin/users'); // Navigate to admin submission page
    } else if (option === 'Settings') {
      navigate('/certificate'); // Navigate to certificate page (or other settings page)
    } 
      else if(option === 'Home'){
        navigate('/user/product')
      } else {
      navigate('/'); // Default navigation if option is unknown
    }
  };

  const buttonOptions = getButtonOptions(role);

  return (
    <Layout>
      <Header style={headerStyle}>
        <div style={{ color: '#fff', fontWeight: 'bold' }}>GYM CRM</div>
        
        {/* Centered Buttons for Desktop */}
        {!isMobile && buttonOptions.length > 0 && (
          <Space>
            {buttonOptions.map((option) => (
              <Button key={option} onClick={() => handleButtonClick(option)}>
                {option}
              </Button>
            ))}
          </Space>
        )}

        <div>
          {isMobile ? (
            <Dropdown overlay={generateMenu(buttonOptions, handleButtonClick)} trigger={['click']}>
              <Button icon={<MenuOutlined />} style={{ color: '#fff', background: 'transparent', border: 'none' }} />
            </Dropdown>
          ) : loggedIn ? (
            <Dropdown
              overlay={
                <Menu>
                  {buttonOptions.map((option) => (
                    <Menu.Item key={option} onClick={() => handleButtonClick(option)}>
                      {option}
                    </Menu.Item>
                  ))}
                  <Menu.Item onClick={() => handleButtonClick('Logout')}>Logout</Menu.Item>
                </Menu>
              }
              trigger={['click']}
            >
              <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#87d068', cursor: 'pointer' }} />
            </Dropdown>
          ) : (
            <div style={{width:"150px", display:'flex' , justifyContent:'space-between'}}>
            <Button onClick={() => handleButtonClick('Login')}>
              Login
            </Button>
            <Button onClick={() => handleButtonClick('Signup')}>
              Signup
            </Button>
            
              </div>
          )}
        </div>
      </Header>

      <Content style={contentStyle}>{children}</Content>

      <Footer style={footerStyle}>Gym CRM ©2023</Footer>
    </Layout>
  );
};

export default LayoutComponent;
